<div
  *ngIf="selectedOption"
  class="!tw-text-white tw-w-full tw-rounded-[4px] tw-p-2 deal-status-picker"
  [ngClass]="dealStageColorClassMap[selectedOption.stage]"
  data-cy="deal-status-display-current"
  matTooltip="{{ selectedOption.display }}"
  mat-flat-button (click)="$event.stopPropagation(); select.open()">
  <div class="column-grid tw-place-items-center tw-h-full">
    <mat-select
      #select
      data-cy="status-select-list"
      hideSingleSelectionIndicator
      [value]="selectedOption"
      (selectionChange)="handleChange($event.value)"
      panelWidth="200px"
      panelClass="deal-status-picker">
      <mat-select-trigger>
        <span class="tw-pr-2 tw-text-white tw-truncate">{{ selectedOption.display }}</span>
      </mat-select-trigger>
      <mat-optgroup data-cy="deal-status-picker-options-group-header" *ngFor="let group of optionGroups" [label]="group.label">
        <mat-option data-cy="deal-status-picker-options-list" *ngFor="let option of group.options" [value]="option">
          <span data-cy="deal-status-display" *ngIf="option">{{ option.display }}</span>
        </mat-option>
      </mat-optgroup>
    </mat-select>
  </div>
</div>
